import { t } from '@lingui/macro';

import { captureError } from '@rover/rsdk/src/modules/ErrorReporting';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { SubmitEmailResponse } from '@rover/types';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import APIError from './APIError';
import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const NEWSLETTER_SIGNUP_URL = 'newsletter-signup/';
export const post = async (email: string): Promise<SubmitEmailResponse> => {
  let data;

  try {
    const formData = new FormData();
    formData.append('email', email);
    const postRequest: any = {
      method: 'post',
      url: fullApiUrl(NEWSLETTER_SIGNUP_URL),
      data: formData,
      config: {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    };
    const ai = getAxiosInstance();
    ({ data } = await ai(postRequest));
  } catch (e: any) {
    const message = t`There was an error while submitting the newsletter signup request.`;
    const apiError = new APIError(message, 500);
    captureError(apiError);
    throw DefaultAPIErrorHandler(e, message);
  }

  if (!data || data.status !== 'success') {
    const message = t`Newsletter signup request failed.`;
    const apiError = new APIError(message, 400);
    throw apiError;
  }

  return {
    isSuccessful: true,
  };
};
